<div class="wf-designer-root">
      <!-- <hr class="line" [ngStyle]="{ background: newColor }" /> -->
    <!-- <app-topnav [clientLogo]="clientLogo" [pagename]="componentName" [prName]="workName"></app-topnav> -->

    <!-- ================================================================ -->
    <!-- TOPBAR                                                           -->
    <!-- ================================================================ -->
    <div class="wf-topbar">
        <!-- <button class="wf-btn wf-btn-ghost" (click)="goBack()" title="Back">
            <span class="wf-back-arrow">←</span>
            <span>Back</span>
        </button>

        <div class="wf-topbar-divider"></div> -->

        <ng-container *ngIf="currentWf">
            <input class="wf-topbar-name" type="text"
                [(ngModel)]="currentWf.wf_name" (input)="markDirty()" (blur)="onNameBlur()"
                placeholder="Workflow name" />
            <span class="wf-badge"
                [ngClass]="'wf-badge-' + ((currentWf.status || 'DRAFT') | lowercase)">
                {{ currentWf.status || 'DRAFT' }}
            </span>
            <span *ngIf="dirty" class="wf-unsaved-dot" title="Unsaved changes"></span>
        </ng-container>

        <div class="wf-topbar-spacer"></div>

        <button class="wf-btn wf-btn-primary" (click)="saveFlow()">Save</button>
        <button *ngIf="currentWf?.status === 'DRAFT'"
            class="wf-btn wf-btn-success" (click)="activateFlow()">Activate</button>
        <button *ngIf="currentWf?.status === 'ACTIVE' || currentWf?.status === 'PAUSED'"
            class="wf-btn" (click)="pauseFlow()">Pause</button>
    </div>

    <!-- Full-page loader while the workflow definition + design fetch is in flight -->
    <div *ngIf="isLoadingDesigner" class="wf-page-loader">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="wf-page-loader-text">Loading workflow…</span>
    </div>

    <!-- Load-failure state. We deliberately render no canvas so saveFlow()
         can never overwrite the real server-side DRAFT with a blank design. -->
    <div *ngIf="!isLoadingDesigner && loadFailed" class="wf-page-loader">
        <span class="wf-page-loader-text">
            Could not load this workflow. Please reload the page to try again.
        </span>
    </div>

    <!-- ================================================================ -->
    <!-- DESIGNER BODY                                                    -->
    <!-- ================================================================ -->
    <div class="wf-body" *ngIf="!isLoadingDesigner && !loadFailed"
         #bodyWrap
         [class.is-fullscreen]="isFullscreen">

        <!-- ============================================================ -->
        <!-- COLUMN A : CANVAS (left)                                     -->
        <!-- ============================================================ -->
        <div class="wf-canvas-wrap" #canvasWrap
             (click)="closeAddMenu()">

            <!-- Palette toggle tab — always visible so the Step Library can
                 be opened/closed even while a config panel is active. -->
            <button class="wf-palette-toggle"
                (click)="togglePalette(); $event.stopPropagation()"
                [title]="effectivePaletteOpen ? 'Hide Step Library' : 'Show Step Library'">
                {{ effectivePaletteOpen ? '→' : '←' }}
            </button>

            <!-- Canvas toolbar — zoom, reset, fullscreen, minimap toggle.
                 Lives outside the scroll container so it stays pinned. -->
            <div class="wf-canvas-toolbar" (click)="$event.stopPropagation()">
                <button class="wf-tb-btn" (click)="zoomOut()"
                    [disabled]="zoom <= 0.4" title="Zoom out (Ctrl -)">−</button>
                <div class="wf-tb-zoom" title="Reset zoom (Ctrl 0)"
                    (click)="zoomReset()">{{ zoomPercent }}%</div>
                <button class="wf-tb-btn" (click)="zoomIn()"
                    [disabled]="zoom >= 1.5" title="Zoom in (Ctrl +)">+</button>
                <button class="wf-tb-btn wf-tb-btn-text"
                    (click)="zoomReset()" [disabled]="zoom === 1"
                    title="Reset zoom to 100% (Ctrl 0)">Reset</button>
                <span class="wf-tb-divider"></span>
                <button class="wf-tb-btn"
                    [class.is-active]="isFullscreen"
                    (click)="toggleFullscreen()"
                    [title]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'">
                    <svg *ngIf="!isFullscreen" viewBox="0 0 16 16" width="14" height="14"
                        fill="none" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M2 6V2h4M14 6V2h-4M2 10v4h4M14 10v4h-4"/>
                    </svg>
                    <svg *ngIf="isFullscreen" viewBox="0 0 16 16" width="14" height="14"
                        fill="none" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M6 2v4H2M10 2v4h4M6 14v-4H2M10 14v-4h4"/>
                    </svg>
                </button>
                <span class="wf-tb-spacer"></span>
                <button class="wf-tb-btn wf-tb-btn-text"
                    [class.is-active]="minimapOpen"
                    (click)="toggleMinimap()" title="Toggle minimap">
                    Map
                </button>
                <span class="wf-tb-hint">Drag node body to move · Alt-drag canvas to pan · Ctrl-wheel to zoom</span>
            </div>

            <!-- Inner scroll container — owns the overflow that used to live on
                 .wf-canvas-wrap. Keeping the wrap non-scrolling lets the
                 absolutely-positioned palette toggle above stay put while the
                 user scrolls a tall flow. -->
            <div class="wf-canvas-scroll" #canvasScroll
                (scroll)="onCanvasScroll()"
                (wheel)="onCanvasWheel($event)"
                (mousedown)="onCanvasMouseDown($event)">
            <!-- Zoom shell. JS sizes this to (naturalCanvasSize × zoom) so the
                 scroll container scrolls the visually-scaled content. The
                 inner .wf-canvas keeps its natural layout and is transformed
                 via CSS scale; it's pinned to its measured natural width so
                 the transform never feeds back into layout. -->
            <div class="wf-zoom-shell" #zoomShell>
            <div class="wf-canvas wf-canvas-2d" #canvasInner *ngIf="design"
                [style.width.px]="canvasW"
                [style.height.px]="canvasH">

                <!-- SVG edge layer — bezier curves between nodes derived
                     from steps[] order + condition branches. Sits behind
                     the node layer (z-index:1). preserveAspectRatio=none
                     stretches the SVG to canvas dimensions exactly. -->
                <svg class="wf-edges" [attr.width]="canvasW" [attr.height]="canvasH"
                    [attr.viewBox]="'0 0 ' + canvasW + ' ' + canvasH"
                    preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <!-- Arrowheads colored per edge kind. SVG marker
                             references can't be styled via CSS in all
                             browsers, so we ship one marker per kind. -->
                        <marker id="wf-arrow-main" viewBox="0 0 10 10" refX="9" refY="5"
                            markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                            <path d="M 0 0 L 10 5 L 0 10 z" fill="#9CA3AF"/>
                        </marker>
                        <marker id="wf-arrow-yes" viewBox="0 0 10 10" refX="9" refY="5"
                            markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                            <path d="M 0 0 L 10 5 L 0 10 z" fill="#10B981"/>
                        </marker>
                        <marker id="wf-arrow-no" viewBox="0 0 10 10" refX="9" refY="5"
                            markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                            <path d="M 0 0 L 10 5 L 0 10 z" fill="#F43F5E"/>
                        </marker>
                    </defs>
                    <path *ngFor="let e of canvasEdges"
                        [attr.d]="e.path"
                        class="wf-edge"
                        [class.is-main]="e.kind === 'main'"
                        [class.is-yes]="e.kind === 'yes'"
                        [class.is-no]="e.kind === 'no'"
                        [attr.marker-end]="'url(#wf-arrow-' + e.kind + ')'"></path>
                    <!-- Dashed connectors from condition / last branch step
                         down to the corresponding "+ Add" anchor. Drawn with
                         the same yes/no palette as live edges so the routing
                         intent stays visually consistent. -->
                    <path *ngFor="let a of canvasBranchAnchors"
                        [attr.d]="a.edgePath"
                        class="wf-edge wf-edge-anchor"
                        [class.is-yes]="a.branch === 'yes'"
                        [class.is-no]="a.branch === 'no'"></path>
                    <!-- Tail anchor for the top-level chain — same dashed
                         style, neutral (main) color since it's not a
                         branch arm. -->
                    <path *ngIf="canvasMainAnchor"
                        [attr.d]="canvasMainAnchor.edgePath"
                        class="wf-edge wf-edge-anchor is-main"></path>
                </svg>

                <!-- Node layer — absolute-positioned cards. Each card
                     reads its position from step.canvas_x / canvas_y.
                     onNodeMouseDown starts free-form drag; onNodeClick
                     opens the config panel for that step. -->
                <div *ngFor="let n of canvasNodes"
                    class="wf-node"
                    [class.is-trigger]="isTriggerStep(n.step)"
                    [class.is-condition]="isConditionStep(n.step)"
                    [class.is-end]="isEndStep(n.step)"
                    [class.is-branch-yes]="n.branch === 'yes'"
                    [class.is-branch-no]="n.branch === 'no'"
                    [class.selected]="configStepIdx === n.topIdx
                        && (n.branch === null ? !configBranch
                            : (configBranch === n.branch && configBranchIdx === n.branchIdx))"
                    [style.left.px]="n.step.canvas_x"
                    [style.top.px]="n.step.canvas_y"
                    [style.width.px]="220"
                    (mousedown)="onNodeMouseDown($event, n.step)"
                    (click)="onNodeClick(n); $event.stopPropagation()">

                    <!-- Branch tag floats above the card on yes/no nodes
                         to make the routing kind unambiguous at a glance. -->
                    <span *ngIf="n.branch === 'yes' && n.branchIdx === 0"
                        class="wf-node-tag wf-node-tag--yes">YES</span>
                    <span *ngIf="n.branch === 'no' && n.branchIdx === 0"
                        class="wf-node-tag wf-node-tag--no">NO</span>

                    <div class="wf-node-card">
                        <div class="wf-node-head">
                            <div class="wf-node-icon"
                                [style.background]="getStepDef(n.step.step_type_id)?.bg"
                                [style.color]="getStepDef(n.step.step_type_id)?.fg">
                                {{ getStepDef(n.step.step_type_id)?.icon }}
                            </div>
                            <div class="wf-node-meta">
                                <div class="wf-node-type"
                                    [style.color]="getStepDef(n.step.step_type_id)?.fg">
                                    {{ isTriggerStep(n.step) ? 'TRIGGER' : getStepDef(n.step.step_type_id)?.cat }}
                                </div>
                                <div class="wf-node-name">{{ n.step.step_label }}</div>
                            </div>
                            <button *ngIf="!isTriggerStep(n.step)"
                                class="wf-node-del"
                                (click)="n.branch
                                    ? removeBranchStep(n.topIdx, n.branch, n.branchIdx!)
                                    : removeStep(n.topIdx);
                                    $event.stopPropagation()"
                                title="Delete step">✕</button>
                        </div>

                        <div class="wf-node-body">
                            <ng-container *ngIf="getConfigPreviewRows(n.step) as rows">
                                <ng-container *ngIf="rows.length; else emptyN">
                                    <div *ngFor="let row of rows | slice:0:2"
                                        class="wf-node-row">
                                        <span class="wf-node-row-label">{{ row.label }}</span>
                                        <span class="wf-node-row-val">{{ row.value }}</span>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-template #emptyN>
                                <span class="wf-node-empty">Click to configure…</span>
                            </ng-template>
                        </div>

                        <!-- Decorative ports — visual hint of input/output.
                             Not draggable in this iteration; reserved for a
                             future port-to-port edge-creation gesture. -->
                        <span *ngIf="!(n.topIdx === 0 && n.branch === null)"
                              class="wf-node-port wf-node-port--in"></span>
                        <span class="wf-node-port wf-node-port--out"></span>
                    </div>
                </div>

                <!-- Branch "+ Add" anchors — one per condition arm. These
                     replace the inline arm "+" buttons that lived in the old
                     linear layout. Each anchor opens the branch palette
                     menu (toggleBranchAddMenu) which feeds addBranchStep. -->
                <div *ngFor="let a of canvasBranchAnchors"
                    class="wf-branch-anchor-2d"
                    [class.is-yes]="a.branch === 'yes'"
                    [class.is-no]="a.branch === 'no'"
                    [style.left.px]="a.x"
                    [style.top.px]="a.y"
                    [style.width.px]="220"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                    <button type="button" class="wf-branch-anchor-btn"
                        [class.is-open]="isBranchAddMenuOpen(a.stepIdx, a.branch, a.afterIdx)"
                        (click)="toggleBranchAddMenu(a.stepIdx, a.branch, a.afterIdx); $event.stopPropagation()"
                        [attr.aria-label]="'Add to ' + (a.branch === 'yes' ? 'YES' : 'NO') + ' branch'">
                        <span class="wf-branch-anchor-plus">+</span>
                        <span class="wf-branch-anchor-label">{{ a.branch === 'yes' ? 'YES' : 'NO' }}</span>
                    </button>
                    <div *ngIf="isBranchAddMenuOpen(a.stepIdx, a.branch, a.afterIdx)"
                        class="wf-add-menu wf-branch-anchor-menu"
                        (click)="$event.stopPropagation()">
                        <ng-container *ngFor="let cat of getBranchPaletteCategories()">
                            <div class="wf-pal-cat">{{ cat }}</div>
                            <div *ngFor="let item of getBranchPaletteItems(cat)"
                                class="wf-pal-item wf-pal-item-sm"
                                (click)="addBranchStep(a.stepIdx, a.branch, a.afterIdx, item.id)">
                                <div class="wf-pal-icon wf-pal-icon-sm"
                                    [style.background]="item.bg" [style.color]="item.fg">
                                    {{ item.icon }}
                                </div>
                                <div>
                                    <div class="wf-pal-name">{{ item.name }}</div>
                                    <div class="wf-pal-desc">{{ item.desc }}</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Tail "+ Add" anchor for the top-level chain. Single
                     anchor below the last non-terminator step; opens the
                     full step palette via toggleAddMenu/addStep. -->
                <div *ngIf="canvasMainAnchor"
                    class="wf-branch-anchor-2d is-main"
                    [style.left.px]="canvasMainAnchor.x"
                    [style.top.px]="canvasMainAnchor.y"
                    [style.width.px]="220"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                    <button type="button" class="wf-branch-anchor-btn"
                        [class.is-open]="activeAddMenu === canvasMainAnchor.afterIdx"
                        (click)="toggleAddMenu(canvasMainAnchor.afterIdx); $event.stopPropagation()"
                        aria-label="Add next step">
                        <span class="wf-branch-anchor-plus">+</span>
                        <span class="wf-branch-anchor-label">ADD</span>
                    </button>
                    <div *ngIf="activeAddMenu === canvasMainAnchor.afterIdx"
                        class="wf-add-menu wf-branch-anchor-menu"
                        (click)="$event.stopPropagation()">
                        <ng-container *ngFor="let cat of getPaletteCategories()">
                            <div class="wf-pal-cat">{{ cat }}</div>
                            <div *ngFor="let item of getPaletteItemsByCategory(cat)"
                                class="wf-pal-item wf-pal-item-sm"
                                (click)="addStep(item.id, canvasMainAnchor.afterIdx)">
                                <div class="wf-pal-icon wf-pal-icon-sm"
                                    [style.background]="item.bg" [style.color]="item.fg">
                                    {{ item.icon }}
                                </div>
                                <div>
                                    <div class="wf-pal-name">{{ item.name }}</div>
                                    <div class="wf-pal-desc">{{ item.desc }}</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Empty state — focal "+" centered on the canvas, click
                     to open the palette picker for the first step. -->
                <div *ngIf="!design.steps || !design.steps.length" class="wf-empty-canvas-2d">
                    <button type="button" class="wf-empty-add"
                        [class.is-open]="activeAddMenu === -1"
                        (click)="toggleAddMenu(-1); $event.stopPropagation()"
                        aria-label="Add first step">
                        <span class="wf-empty-add-plus">+</span>
                    </button>
                    <div class="wf-empty-label">Add your first step</div>
                    <div *ngIf="activeAddMenu === -1" class="wf-add-menu wf-empty-menu"
                        (click)="$event.stopPropagation()">
                        <ng-container *ngFor="let cat of getPaletteCategories()">
                            <div class="wf-pal-cat">{{ cat }}</div>
                            <div *ngFor="let item of getPaletteItemsByCategory(cat)"
                                class="wf-pal-item wf-pal-item-sm"
                                (click)="addStep(item.id, -1)">
                                <div class="wf-pal-icon wf-pal-icon-sm"
                                    [style.background]="item.bg" [style.color]="item.fg">
                                    {{ item.icon }}
                                </div>
                                <div>
                                    <div class="wf-pal-name">{{ item.name }}</div>
                                    <div class="wf-pal-desc">{{ item.desc }}</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </div>
            </div>
            </div>

            <!-- Minimap. Sits at wrap level (sibling of scroll) so it floats
                 above the canvas without being affected by the canvas's
                 transform. Click anywhere on it to pan to that location. -->
            <div *ngIf="minimapOpen && design" class="wf-minimap"
                (click)="onMinimapClick($event); $event.stopPropagation()"
                title="Click to pan">
                <div class="wf-minimap-inner">
                    <div *ngFor="let n of minimapNodes"
                        class="wf-minimap-node"
                        [class.is-trigger]="n.kind === 'trigger'"
                        [class.is-condition]="n.kind === 'condition'"
                        [class.is-end]="n.kind === 'end'"
                        [style.left.px]="n.left"
                        [style.top.px]="n.top"
                        [style.width.px]="n.width"
                        [style.height.px]="n.height"></div>
                    <div class="wf-minimap-vp"
                        [style.left.px]="minimapViewport.left"
                        [style.top.px]="minimapViewport.top"
                        [style.width.px]="minimapViewport.width"
                        [style.height.px]="minimapViewport.height"></div>
                </div>
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- COLUMN B : RIGHT PANEL COLUMN                               -->
        <!-- Config panel and Step Library stack here. Both can be open  -->
        <!-- simultaneously — config on top, palette below.              -->
        <!-- ============================================================ -->
        <div class="wf-right-col" *ngIf="(paletteOpen && configStepIdx === null) || (design && configStepIdx !== null)">

        <!-- Step Library (palette) — only shown when no config panel is open.
             paletteOpen is still toggled freely so the state is remembered
             and restored correctly when the config panel closes. -->
        <div class="wf-palette" *ngIf="paletteOpen && configStepIdx === null">
            <div class="wf-palette-head">Step Library</div>
            <div class="wf-palette-search">
                <input type="text" [(ngModel)]="paletteSearch" placeholder="Search steps…" />
            </div>
            <div class="wf-palette-scroll">
                <ng-container *ngFor="let cat of getPaletteCategories()">
                    <div class="wf-pal-cat">{{ cat }}</div>
                    <div *ngFor="let item of getPaletteItemsByCategory(cat)" class="wf-pal-item"
                        (click)="addStep(item.id, (design && design.steps && design.steps.length) ? design.steps.length - 1 : -1)">
                        <div class="wf-pal-icon" [style.background]="item.bg" [style.color]="item.fg">
                            {{ item.icon }}
                        </div>
                        <div>
                            <div class="wf-pal-name">{{ item.name }}</div>
                            <div class="wf-pal-desc">{{ item.desc }}</div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Config panel — stacks above the palette when both are open. -->
        <div class="wf-config-panel" *ngIf="design && configStepIdx !== null">
            <ng-container *ngIf="getConfigStep() as step">

                <!-- Unsaved-step banner — shown while a newly-added step has
                     not yet been Applied. Informs the user they need to Apply
                     or Discard before the step is persisted/removed. -->
                <div *ngIf="isStepUnsaved" class="wf-cp-unsaved-banner">
                    <svg width="14" height="14" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;margin-top:1px">
                        <path d="M10 2L2 17h16L10 2z" stroke="currentColor" stroke-width="1.5"
                            stroke-linejoin="round"/>
                        <path d="M10 8v4M10 14.5v.5" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round"/>
                    </svg>
                    <span class="ps-2">New step — click <strong>Apply</strong> to keep or <strong>Discard</strong> to remove</span>
                </div>

                <!-- Header -->
                <div class="wf-cp-header">
                    <div class="wf-cp-icon"
                        [style.background]="getStepDef(step.step_type_id)?.bg"
                        [style.color]="getStepDef(step.step_type_id)?.fg">
                        {{ getStepDef(step.step_type_id)?.icon }}
                    </div>
                    <span class="wf-cp-title">
                        {{ getStepDef(step.step_type_id)?.name }}
                    </span>
                    <button class="wf-cp-close" (click)="closeConfig()">×</button>
                </div>

                <!-- Body -->
                <div class="wf-cp-body" *ngIf="configForm" id="wf_designer_id">
                    <form [formGroup]="configForm">

                        <!-- Step label (always first) -->
                        <div class="field">
                            <mat-label>Step Label <span class="req">*</span></mat-label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput formControlName="step_label" />
                            </mat-form-field>
                        </div>

                        <!-- Dynamic fields -->
                        <ng-container *ngFor="let field of getFieldsForStep()">

                            <!-- Section divider -->
                            <div *ngIf="field.section" class="wf-cf-section">
                                {{ field.section }}
                            </div>

                            <!-- Regular fields: must have a key, not be hidden, and pass any
                                 showWhen / hideWhen conditions. showWhen renders the field
                                 only when the referenced control matches; hideWhen does the
                                 inverse (e.g. Subject/Body hidden when "Choose template" is on). -->
                            <ng-container
                                *ngIf="field.key && !field.hidden &&
                                       (!field.showWhen ||
                                        configForm?.get(field.showWhen.key)?.value === field.showWhen.equals) &&
                                       (!field.hideWhen ||
                                        configForm?.get(field.hideWhen.key)?.value !== field.hideWhen.equals)">

                                <!-- Text input -->
                                <div *ngIf="field.type === 'text'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input matInput [formControlName]="field.key"
                                            [placeholder]="field.placeholder || ''" />
                                    </mat-form-field>
                                </div>

                                <!-- Number input -->
                                <div *ngIf="field.type === 'number'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input matInput type="number" [formControlName]="field.key"
                                            [placeholder]="field.placeholder || ''" />
                                    </mat-form-field>
                                </div>

                                <!-- Select dropdown -->
                                <div *ngIf="field.type === 'select'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-select [formControlName]="field.key" [compareWith]="compareById">
                                            <mat-option *ngFor="let opt of (optionCache[field.key] || [])"
                                                [value]="opt.id">{{ opt.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Textarea -->
                                <div *ngIf="field.type === 'textarea'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <textarea matInput rows="3" [formControlName]="field.key"
                                            [placeholder]="field.placeholder || ''"></textarea>
                                    </mat-form-field>
                                </div>

                                <!-- Toggle -->
                                <div *ngIf="field.type === 'toggle'" class="wf-cf-toggle-row">
                                    <span class="wf-cf-toggle-label">{{ field.label }}</span>
                                    <label class="wf-toggle">
                                        <input type="checkbox" [formControlName]="field.key" />
                                        <span class="wf-toggle-slider"></span>
                                    </label>
                                </div>

                                <!-- Time input -->
                                <div *ngIf="field.type === 'time'" class="field">
                                    <mat-label>{{ field.label }}</mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input matInput type="time" [formControlName]="field.key" />
                                    </mat-form-field>
                                </div>

                                <!-- Date picker (used by Start date Custom) -->
                                <div *ngIf="field.type === 'date'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input matInput [matDatepicker]="picker"
                                            [formControlName]="field.key"
                                            [placeholder]="field.placeholder || 'Pick a date'" />
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <!-- Assignees: searchable user picker, multi-select with chip list -->
                                <div *ngIf="field.type === 'assignees'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <div class="wf-assignee-search">
                                        <input class="wf-assignee-input" type="text"
                                            [(ngModel)]="assigneeInput"
                                            [ngModelOptions]="{ standalone: true }"
                                            [placeholder]="field.placeholder || 'Search user by name or email…'"
                                            (focus)="onAssigneeSearchFocus(field.key)"
                                            (input)="onAssigneeSearchInput($event)"
                                            (blur)="onAssigneeSearchBlur()" />
                                        <div class="wf-assignee-results"
                                            *ngIf="showAssigneeResults && assigneeFieldKey === field.key">
                                            <div *ngIf="isSearchingUsers" class="wf-assignee-loading">
                                                <mat-spinner diameter="16"></mat-spinner>
                                                <span>Loading users…</span>
                                            </div>
                                            <div *ngIf="!isSearchingUsers && !assigneeSearchResults.length"
                                                class="wf-assignee-empty">
                                                No users found
                                            </div>
                                            <div *ngFor="let u of assigneeSearchResults"
                                                class="wf-assignee-result"
                                                [class.is-selected]="isAssigneeSelected(field.key, u)"
                                                (mousedown)="$event.preventDefault(); selectAssignee(field.key, u)">
                                                <div class="wf-assignee-name">
                                                    {{ u.usr_display_nm || u.user_id }}
                                                </div>
                                                <div class="wf-assignee-sub">{{ u.user_id }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wf-assignee-chips" *ngIf="getAssignees(field.key).length">
                                        <span *ngFor="let email of getAssignees(field.key); let ai = index"
                                            class="wf-assignee-chip">
                                            <span class="wf-assignee-chip-name">
                                                {{ assigneeDisplayMap[email] || email }}
                                            </span>
                                            <button type="button" class="wf-assignee-chip-x"
                                                (click)="removeAssignee(field.key, ai)"
                                                [attr.aria-label]="'Remove ' + email">×</button>
                                        </span>
                                    </div>
                                </div>

                                <!-- Patient Status multi-select picker (same chip/search UX as Assignees) -->
                                <div *ngIf="field.type === 'status-picker'" class="field">
                                    <mat-label>{{ field.label }}<span *ngIf="field.req" class="req">&nbsp;*</span></mat-label>
                                    <div class="wf-assignee-search">
                                        <input class="wf-assignee-input" type="text"
                                            [(ngModel)]="statusPickerInput"
                                            [ngModelOptions]="{ standalone: true }"
                                            [placeholder]="field.placeholder || 'Search patient status…'"
                                            (focus)="onStatusPickerFocus(field.key)"
                                            (input)="onStatusPickerInput($event)"
                                            (blur)="onStatusPickerBlur()" />
                                        <div class="wf-assignee-results"
                                            *ngIf="showStatusResults && statusPickerFieldKey === field.key">
                                            <div *ngIf="isLoadingStatuses" class="wf-assignee-loading">
                                                <mat-spinner diameter="16"></mat-spinner>
                                                <span>Loading…</span>
                                            </div>
                                            <div *ngIf="!isLoadingStatuses && !statusPickerResults.length"
                                                class="wf-assignee-empty">
                                                No options found
                                            </div>
                                            <div *ngFor="let s of statusPickerResults"
                                                class="wf-assignee-result"
                                                [class.is-selected]="isStatusSelected(field.key, s)"
                                                (mousedown)="$event.preventDefault(); selectStatus(field.key, s)">
                                                <div class="wf-assignee-name">{{ s.label }}</div>
                                                <div class="wf-assignee-sub">{{ s.code }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wf-assignee-chips" *ngIf="getStatusValues(field.key).length">
                                        <span *ngFor="let val of getStatusValues(field.key); let si = index"
                                            class="wf-assignee-chip">
                                            <span class="wf-assignee-chip-name">
                                                {{ statusDisplayMap[val] || val }}
                                            </span>
                                            <button type="button" class="wf-assignee-chip-x"
                                                (click)="removeStatus(field.key, si)"
                                                [attr.aria-label]="'Remove ' + val">×</button>
                                        </span>
                                    </div>
                                </div>

                                <!-- Tags -->
                                <div *ngIf="field.type === 'tags'" class="wf-cf">
                                    <label class="wf-cf-label">
                                        {{ field.label }}
                                        <span *ngIf="field.req" class="req">*</span>
                                    </label>
                                    <div class="wf-tag-input-row">
                                        <input #tagInput [placeholder]="field.placeholder || ''"
                                            (keydown.enter)="addTag(field.key, tagInput.value); tagInput.value = ''; $event.preventDefault()" />
                                        <button type="button" class="wf-btn wf-btn-sm"
                                            (click)="addTag(field.key, tagInput.value); tagInput.value = ''">Add</button>
                                    </div>
                                    <div class="wf-tag-list">
                                        <span *ngFor="let tag of tagValues[field.key]; let ti = index"
                                            class="wf-tag">
                                            {{ tag }}
                                            <span class="wf-tag-x"
                                                (click)="removeTag(field.key, ti)">×</span>
                                        </span>
                                    </div>
                                </div>

                            </ng-container>
                        </ng-container>

                    </form>
                </div>

                <!-- Footer -->
                <div class="wf-cp-footer">
                    <button class="wf-btn" (click)="closeConfig()">Discard</button>
                    <button class="wf-btn wf-btn-primary wf-cp-save"
                        (click)="applyConfig()">Apply</button>
                </div>

            </ng-container>
        </div><!-- /wf-config-panel -->

        </div><!-- /wf-right-col -->
    </div><!-- /wf-body -->
</div><!-- /wf-designer-root -->
